<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('navigation.complaints') }}
      </h1>
      <div class="ml-auto">
        <v-btn
          outlined
          large
          @click="toggleFilters"
        >
          <v-icon left>
            mdi-filter-variant
          </v-icon>
          {{ $t('common.filter') }}
        </v-btn>
      </div>
    </div>
    <table-filters
      v-if="isFilterShown"
      :filters="filters"
      @search="getItems(true)"
    />
    <v-data-table
      class="row-clickable"
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
      @click:row="goTo"
    />
  </div>
</template>

<script>
import TableFilters from '@/components/common/TableFilters';

export default {
  name: 'Complaints',
  components: {
    TableFilters,
  },
  data() {
    return {
      total: 0,
      items: [],
      loading: false,
      options: {
        page: 1,
      },
      headers: [
        {
          text: this.$t('common.orders.complaint_code'),
          value: 'complaintCode',
        },
        {
          text: this.$t('common.order_number'),
          value: 'orderNumber',
        }, {
          text: this.$t('common.invoice_number'),
          value: 'invoiceNumber',
        }, {
          text: this.$t('common.invoice_date'),
          value: 'invoiceDate',
        },
        {
          text: this.$t('common.delivery_date'),
          value: 'deliveryDate',
        },
        {
          text: this.$t('common.status'),
          value: 'status',
        },
        {
          text: this.$t('common.status_date'),
          value: 'statusDate',
        },
        {
          text: this.$t('common.originator'),
          value: 'createdBy.login',
        },
      ],
      isFilterShown: false,
      filters: [
      //   {
      //   label: this.$t('common.date'),
      //   key: 'statusDate',
      //   type: 'date',
      //   value: '',
      // },
        // {
        //   label: this.$t('common.document_number'),
        //   key: 'number',
        //   value: '',
        // }, {
        //   label: this.$t('common.invoice_number'),
        //   key: 'invoiceNumber',
        //   value: '',
        // },
        {
          label: this.$t('common.status'),
          key: 'status',
          value: '',
          type: 'select',
          options: [{
            value: 'Registered',
            text: this.$t('enums.complaint_statuses.registered'),
          }],
        }, {
          label: this.$t('common.originator'),
          key: 'createdBy',
          value: '',
        }],
    };
  },
  computed: {
    params() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const params = {
        populate: ['createdBy', 'invoice'],
      };

      params.query = this.filters.reduce((acc, { key, value }) => {
        if (!value) {
          return acc;
        }

        acc[key] = {
          $regex: `.*${value}.*`,
          $options: 'i',
        };

        return acc;
      }, {});

      if (itemsPerPage !== -1) {
        params.pageSize = itemsPerPage;
        params.page = page;
      }

      if (sortBy && sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      return params;
    },
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },
  methods: {
    async getItems(filtered) {
      this.loading = true;

      if (filtered) {
        this.options.page = 1;
      }

      const { data } = await this.$http.get('complaints', { params: this.params }).finally(() => {
        this.loading = false;
      });

      if (data.rows.length) {
        this.items = data.rows.map((it) => ({
          ...it,
          statusDate: it.statusDate && this.$moment(it.statusDate).format('L LT'),
          invoiceDate: it.invoiceDate && this.$moment(it.invoiceDate).format('L LT'),
          deliveryDate: it.deliveryDate && this.$moment(it.date).format('L LT'),
          status: it.status && this.$t(`enums.complaint_statuses.${it.status.toLowerCase()}`),
        }));
      } else {
        this.items = data.rows;
      }

      this.total = data.total;
    },
    toggleFilters() {
      this.isFilterShown = !this.isFilterShown;
    },
    goTo({ id }) {
      this.$router.push(`/complaints/${id}`);
    },
  },
};
</script>

<style lang="scss">
.row-clickable tr {
  cursor: pointer;
}
</style>
